import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../../lib/api";
import { useCjCart } from "../../context/CjCartContext";

const OrderSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const [order, setOrder] = useState(null);
  const { clear } = useCjCart();
  const attempts = useRef(0);

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/cj/checkout/status/${sid}`);
        if (data.payment_status === "paid") {
          setOrder(data); setState("paid"); clear(); return;
        }
        if (data.status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      attempts.current += 1;
      if (attempts.current < 30 && !stop) setTimeout(poll, 2500);
      else if (!stop) setState("pending");
    };
    poll();
    return () => { stop = true; };
  }, [sid, clear]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="order-success">
      {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-taven-gold" /><p className="mt-4 text-sm text-muted-foreground">Confirming your payment…</p></>}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-green-600" />
          <h1 className="text-2xl font-black font-display mt-4">Order Confirmed!</h1>
          <p className="text-sm text-muted-foreground mt-2">Thank you. Your order <span className="font-bold text-black" data-testid="success-order-number">{order?.order_number}</span> is being prepared for fulfillment.</p>
          <Link to="/market" className="inline-block mt-6 px-6 py-2.5 rounded-full bg-black text-white text-sm font-bold">Continue Shopping</Link>
        </>
      )}
      {state === "pending" && <><Loader2 className="w-10 h-10 mx-auto text-taven-gold" /><p className="mt-4 text-sm text-muted-foreground">Payment is processing. Check your email for confirmation.</p></>}
      {state === "error" && <><XCircle className="w-12 h-12 mx-auto text-taven-orange" /><h1 className="text-xl font-black font-display mt-4">Payment not completed</h1><Link to="/market/cart" className="inline-block mt-5 px-6 py-2.5 rounded-full bg-black text-white text-sm font-bold">Back to Cart</Link></>}
    </div>
  );
};

export default OrderSuccess;
